export enum IneventorySortingType {
  Listing = 'listing',
  Event = 'event', // TODO when working on portfolio page
}

export type InventorySortingOrder = 'desc' | 'asc';

export enum ListingSortByFields {
  Price = 'price',
  UnitCost = 'unitCost',
  Quantity = 'quantity',
  Seating = 'seating',
}

export enum EventSortByFields {
  EventDate = 'eventDate',
  EventName = 'eventName',
  VenueName = 'venueName',
  UnsoldListings = 'unsoldListings',
  TicketCount = 'ticketCount',
}

export type InventoryListingSorting = {
  sortBy: ListingSortByFields;
  order: InventorySortingOrder;
};

export type InventoryEventSorting = {
  sortBy: EventSortByFields;
  order: InventorySortingOrder;
};

export enum ListingSortDisplayConfig {
  HideAllDefeats = 'hideAllDefeats',
  HideAllFanInventory = 'hideAllFanInventory',
  HideSoldInventory = 'hideSoldInventory',
}

export enum EventSortDisplayConfig {
  HideSoldThrough = 'hideSoldThrough',
  HidePortfolioInsights = 'hidePortfolioInsights',
  CollapseAllGroups = 'collapseAllGroups',
}

type InventoryListingDisplayConfig = {
  configs: ListingSortDisplayConfig[];
};

type InventoryEventDisplayConfig = {
  configs: EventSortDisplayConfig[];
};

export type InventoryListingSortingCriteria = {
  type: IneventorySortingType.Listing;
  sorting: InventoryListingSorting;
  displayConfig: InventoryListingDisplayConfig;
};

export type InventoryEventSortingCriteria = {
  type: IneventorySortingType.Event;
  sorting: InventoryEventSorting;
  displayConfig: InventoryEventDisplayConfig;
};

export type InventorySortingCriteria =
  | InventoryListingSortingCriteria
  | InventoryEventSortingCriteria;

export enum ListingTileFilterTarget {
  All = 'all',
  MyInventory = 'myInventory',
  CompInventory = 'compInventory',
}

export type ListingTileQuantityFilter = {
  quantities: string[];
  target: ListingTileFilterTarget;
};
export type ListingTileFilters = {
  sections?: string[];
  listingQuantities?: ListingTileQuantityFilter;
};
